import React from 'react';

const Home = () => (
  <section
    id="home"
    className="module-hero module-parallax module-fade module-full-height bg-dark-30"
    data-background="assets/images/bg1.jpg"
    style={{ backgroundPosition: '12% 30%' }}
  >
    <div className="hs-caption container">
      <div className="caption-content">
        <h1 className="hs-title-size-4 font-alt m-b-30">
          Bianca Lucia Music Studio
        </h1>
        <div className="hs-title-size-1 font-inc">
          Bianca Lucia Dominguez is a soprano and music instructor, based in the Bay Area.
      </div>
      </div>
    </div>
  </section >
);

export default Home;
